// #162870

// rgba(225, 245, 255, 1)

import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useToolbarTitleStyles = makeThemedStyles("ToolbarTitle", (theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    fontSize: "20px",
    color: "white",
    background: "#162870",
    minHeight: "50px",
    padding: "0px 20px 0px 20px",
  },
}));

const ToolbarTitle = (props: React.PropsWithChildren<{}>) => {
  const styles = useToolbarTitleStyles();
  return <div className={styles.root}>{props.children}</div>;
};

export default ToolbarTitle;
